import { render, staticRenderFns } from "./FacturaTable.vue?vue&type=template&id=7b163a54&scoped=true&"
import script from "./FacturaTable.vue?vue&type=script&lang=ts&"
export * from "./FacturaTable.vue?vue&type=script&lang=ts&"
import style0 from "./FacturaTable.vue?vue&type=style&index=0&id=7b163a54&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b163a54",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('7b163a54', component.options)
    } else {
      api.reload('7b163a54', component.options)
    }
    module.hot.accept("./FacturaTable.vue?vue&type=template&id=7b163a54&scoped=true&", function () {
      api.rerender('7b163a54', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Facturacion/FacturaTable.vue"
export default component.exports